/* Performance Shorts: ship clock, delivery estimate, size finder, scroll-to-buy, in-view video. */
(function () {
  'use strict';
  var HST_OFFSET = -10; // Hawaii has no daylight saving time
  // US federal holidays (observed dates): no shipping, no USPS delivery. Update yearly.
  var HOLIDAYS = {
    '2026-01-01': 1, '2026-01-19': 1, '2026-02-16': 1, '2026-05-25': 1, '2026-06-19': 1, '2026-07-03': 1,
    '2026-09-07': 1, '2026-10-12': 1, '2026-11-11': 1, '2026-11-26': 1, '2026-12-25': 1,
    '2027-01-01': 1, '2027-01-18': 1, '2027-02-15': 1, '2027-05-31': 1, '2027-06-18': 1, '2027-07-05': 1,
    '2027-09-06': 1, '2027-10-11': 1, '2027-11-11': 1, '2027-11-25': 1, '2027-12-24': 1, '2027-12-31': 1
  };
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });

  // "Hawaii wall clock" as a Date whose UTC fields hold Hawaii time.
  function hawaiiNow() { return new Date(Date.now() + HST_OFFSET * 3600000); }
  function dayOnly(d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); }
  function key(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d) { var w = d.getUTCDay(); return w > 0 && w < 6 && !HOLIDAYS[key(d)]; }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function nextBiz(d) { var x = addDays(d, 1); while (!isBiz(x)) x = addDays(x, 1); return x; }
  function addBiz(d, n) { var x = d; for (var i = 0; i < n; i++) x = nextBiz(x); return x; }

  function shipInfo(cutoff) {
    var now = hawaiiNow(), today = dayOnly(now);
    var hours = now.getUTCHours() + now.getUTCMinutes() / 60;
    var open = isBiz(today) && hours < cutoff;
    var ship = open ? today : nextBiz(today);
    var minsLeft = open ? Math.max(1, Math.round((cutoff - hours) * 60)) : 0;
    return { open: open, ship: ship, today: today, minsLeft: minsLeft };
  }
  function left(mins) { var h = Math.floor(mins / 60), m = mins % 60; return (h ? h + ' h ' : '') + m + ' min'; }
  function shipWord(info) {
    if (info.open) return 'today';
    var diff = Math.round((info.ship - info.today) / 86400000);
    return diff === 1 ? 'tomorrow' : DAYS[info.ship.getUTCDay()];
  }

  // The main add-to-cart button. When the selected size or color is sold out, the theme disables it.
  function mainAtc() {
    return document.querySelector('product-form form[action*="/cart/add"] [name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]:not(.stAddtocart_js)');
  }

  function renderEta(el) {
    var atc = mainAtc();
    if (atc && atc.disabled) { el.hidden = true; el.setAttribute('data-state', 'soldout'); return; }
    var cutoff = parseFloat(el.getAttribute('data-cutoff')) || 13;
    var info = shipInfo(cutoff);
    var from = addBiz(info.ship, 5), to = addBiz(info.ship, 7);
    var s = el.querySelector('[data-psp-eta-ship]'), l = el.querySelector('[data-psp-eta-left]'), d = el.querySelector('[data-psp-eta-date]');
    if (s) s.textContent = 'Ships ' + shipWord(info) + ' from Maui.';
    if (l) l.innerHTML = info.open ? 'Order within <b>' + left(info.minsLeft) + '</b>.' : '';
    if (d) d.innerHTML = 'Free US delivery, estimated <b>' + fmt.format(from) + ' – ' + fmt.format(to) + '</b>';
    el.setAttribute('data-state', info.open ? 'open' : 'closed');
    el.hidden = false;
  }

  function renderClock(el) {
    var cutoff = parseFloat(el.getAttribute('data-cutoff')) || 13;
    var info = shipInfo(cutoff), txt = el.querySelector('.psp-clock__txt');
    if (!txt) return;
    txt.innerHTML = info.open
      ? 'Order in <b>' + left(info.minsLeft) + '</b> and it ships today from Maui.'
      : 'Order now and it ships <b>' + shipWord(info) + '</b> from Maui.';
    el.setAttribute('data-state', info.open ? 'open' : 'closed');
  }

  function finder(root) {
    var box = root.querySelector('[data-psp-finder]'), chart = root.querySelector('[data-psp-chart]');
    if (!box || !chart || box.getAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    var rows = [].slice.call(chart.querySelectorAll('tbody tr')).filter(function (r) {
      return r.getAttribute('data-waist-min') !== '' && r.getAttribute('data-waist-max') !== '';
    });
    var inp = box.querySelector('input'), out = box.querySelector('output'), btn = box.querySelector('[data-psp-find]');
    function run() {
      var w = parseFloat(inp.value);
      rows.forEach(function (r) { r.classList.remove('is-match'); });
      if (!w) { out.textContent = 'Enter your waist in inches.'; return; }
      var hit = rows.filter(function (r) {
        return w >= parseFloat(r.getAttribute('data-waist-min')) && w <= parseFloat(r.getAttribute('data-waist-max'));
      });
      if (hit.length === 1) {
        hit[0].classList.add('is-match');
        out.innerHTML = 'Order a <b>size ' + hit[0].getAttribute('data-size') + '</b>. It’s highlighted in the chart.';
      } else if (hit.length > 1) {
        hit.forEach(function (r) { r.classList.add('is-match'); });
        out.innerHTML = 'You’re between <b>' + hit.map(function (r) { return r.getAttribute('data-size'); }).join(' and ') + '</b>. Email jz@mauishirts.com and we’ll measure both for you.';
      } else {
        out.innerHTML = 'That’s outside this chart. Email jz@mauishirts.com and we’ll help you find a fit.';
      }
    }
    if (btn) btn.addEventListener('click', run);
    if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
  }

  function toBuy(e) {
    e.preventDefault();
    var target = document.querySelector('variant-selects fieldset:not(.hide), variant-selects .product-form__input:not(.hide)') ||
      document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function videos() {
    var wraps = document.querySelectorAll('[data-psp-autoplay] video');
    if (!wraps.length) return;
    if (!('IntersectionObserver' in window)) { [].forEach.call(wraps, function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    [].forEach.call(wraps, function (v) { io.observe(v); });
  }

  // Gallery clean-up. Runs before the theme builds the slider (this file loads earlier).
  // Hides extra copies of the same photo (Shopify names a re-upload "<name>_<36-character id>.<ext>")
  // and banner-shaped images wider than 2.4:1. The product's media is not changed.
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function stemOf(src) {
    var f = (src || '').split('?')[0].split('/').pop();
    var stem = f.replace(/[.][a-z0-9]+$/i, '');
    var parts = stem.split('_');
    if (parts.length > 1 && UUID.test(parts[parts.length - 1])) { parts.pop(); stem = parts.join('_'); }
    return stem;
  }
  function cleanGallery() {
    [].forEach.call(document.querySelectorAll('media-gallery'), function (gal) {
      var wrap = gal.querySelector('.primgSlider .swiper-wrapper');
      var thumbsWrap = gal.querySelector('.pr_thumbs .swiper-wrapper');
      if (!wrap) return;
      var slides = [].slice.call(wrap.children).filter(function (el) { return el.classList.contains('swiper-slide'); });
      var thumbs = thumbsWrap ? [].slice.call(thumbsWrap.children) : [];
      var seen = {}, drop = [];
      slides.forEach(function (sl, i) {
        var img = sl.querySelector('img');
        if (!img) return;
        var stem = stemOf(img.getAttribute('src'));
        var w = parseFloat(img.getAttribute('width')), h = parseFloat(img.getAttribute('height'));
        if (seen[stem] || (w && h && w / h > 2.4)) drop.push(i); else seen[stem] = 1;
      });
      if (!drop.length || drop.length >= slides.length) return;
      drop.forEach(function (i) { slides[i].remove(); if (thumbs[i]) thumbs[i].remove(); });
      var n = 0;
      [].forEach.call(wrap.children, function (el) { if (el.classList.contains('swiper-slide')) el.setAttribute('data-slide', n++); });
      n = 0;
      if (thumbsWrap) [].forEach.call(thumbsWrap.children, function (el) { el.setAttribute('data-slide', n++); });
      var first = wrap.querySelector('.swiper-slide img');
      if (first) { first.removeAttribute('loading'); first.classList.remove('swiper-lazy'); }
      var kept = wrap.querySelectorAll('.swiper-slide').length;
      if (kept === 1) {
        var nav = gal.querySelector('.thumbs_nav'); if (nav) nav.classList.add('hide');
        var big = gal.querySelector('.pr_lg_img'); if (big) big.classList.add('w_100');
      }
      // A size whose photo was a hidden copy keeps showing the current photo.
      var target = gal.getAttribute('data-target');
      if (target && !wrap.querySelector('[data-id="' + target + '"]')) {
        var f = wrap.querySelector('.swiper-slide[data-id]');
        if (f) gal.setAttribute('data-target', f.getAttribute('data-id'));
      }
    });
  }

  // Size-guide pop-up: the theme's "Size chart" link opens #sizechart. Fill it with the board-short guide.
  function sizePopup() {
    var tpl = document.getElementById('psp-fit-pop'), box = document.getElementById('sizechart');
    if (!tpl || !box || !tpl.content) return;
    box.innerHTML = '';
    box.appendChild(tpl.content.cloneNode(true));
    box.classList.add('psp-sizechart');
  }

  // Sticky add-to-cart bar: the theme pre-selects the first size in stock, so a shopper who scrolls
  // down and taps the bar could get a size they never picked. Until a size is chosen, the bar's button
  // says "Choose size" and takes the shopper to the size buttons instead of adding to the cart.
  // The stock line follows the same rule: until a size is chosen it describes the style in the
  // selected color ("In stock in 10 of 11 sizes"), not the size the theme happened to pre-select.
  function sizeGuard() {
    var picker = document.querySelector('variant-selects');
    if (!picker) return;
    var groups = [].slice.call(picker.querySelectorAll('fieldset, .product-form__input'));
    var group = groups.filter(function (g) {
      if (g.classList.contains('hide')) return false;
      var lab = g.querySelector('legend, label');
      return lab && /^(size|waist)/i.test((lab.textContent || '').trim());
    })[0];
    if (!group) return;
    var info = picker.closest('product-info') || document;
    var bar = document.querySelector('.stickyCart .stAddtocart_js');
    var label = bar ? (bar.querySelector('.btnin') || bar) : null;
    var original = label ? label.textContent : '';
    var WAIT = 'Choose size';
    var chosen = /[?&]variant=/.test(location.search);
    var changed = false;
    var saved = null;
    var variants = [];
    try {
      variants = JSON.parse((picker.querySelector('script[type="application/json"]') || {}).textContent || '[]') || [];
    } catch (err) { variants = []; }
    function pos(g) { var m = String(g.className || '').match(/pvOpt([0-9]+)/); return m ? +m[1] : -1; }
    var sizePos = pos(group);
    function value(g) {
      var s = g.querySelector('select');
      if (s) return s.value;
      var r = g.querySelector('input:checked');
      return r ? r.value : null;
    }
    function inGroup(el) { return !!(el && el.closest && el.closest('fieldset, .product-form__input') === group); }
    function stockEl() { return info.querySelector('[id^="Inventory-"] .stockLbl'); }
    function summary() {
      if (sizePos < 0 || !variants.length) return '';
      var fixed = [];
      groups.forEach(function (g) { var p = pos(g); if (p > -1 && p !== sizePos) fixed.push([p, value(g)]); });
      var all = {}, open = {};
      variants.forEach(function (v) {
        var o = v.options || [];
        for (var i = 0; i < fixed.length; i++) { if (fixed[i][1] != null && o[fixed[i][0]] !== fixed[i][1]) return; }
        all[o[sizePos]] = 1;
        if (v.available) open[o[sizePos]] = 1;
      });
      var t = Object.keys(all).length, n = Object.keys(open).length;
      if (t < 2 || !n) return '';
      return n === t ? 'In stock in all ' + t + ' sizes' : 'In stock in ' + n + ' of ' + t + ' sizes';
    }
    function prime() {
      if (chosen) return;
      var el = stockEl(), txt = summary();
      if (!el || !txt || el.textContent === txt) return;
      saved = { text: el.textContent, cls: el.className };
      el.textContent = txt;
      el.classList.remove('lowstock', 'outstock', 'preorder');
      el.classList.add('instock', 'psp-sum');
    }
    function restore() {
      var el = stockEl();
      if (el && saved && el.classList.contains('psp-sum')) { el.textContent = saved.text; el.className = saved.cls; }
      saved = null;
    }
    function done() {
      if (chosen) return;
      chosen = true;
      if (label && label.textContent === WAIT) label.textContent = original;
      var m = group.querySelector('.psp-pick-msg');
      if (m) m.parentNode.removeChild(m);
    }
    if (!chosen && label) label.textContent = WAIT;
    prime();
    // The theme swaps in a new stock line after every option change. While no size has been
    // chosen (for example after a color change), put the style summary back.
    var box = info.querySelector('[id^="Inventory-"]');
    if (box && 'MutationObserver' in window) {
      new MutationObserver(function () { if (!chosen) prime(); }).observe(box, { childList: true, subtree: true, characterData: true });
    }
    picker.addEventListener('change', function (e) { if (inGroup(e.target)) { changed = true; done(); } }, true);
    // Tapping the size that is already selected fires no change event, but it is still a choice.
    group.addEventListener('click', function (e) {
      if (chosen || !e.target.closest || !e.target.closest('input, label')) return;
      changed = false;
      setTimeout(function () { if (!changed && !chosen) { done(); restore(); } }, 0);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.stickyOpt li.vrOpt')) done();
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.stAddtocart_js');
      if (!b || chosen) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      group.classList.remove('psp-pick');
      void group.offsetWidth;
      group.classList.add('psp-pick');
      var m = group.querySelector('.psp-pick-msg');
      if (!m) {
        m = document.createElement('p');
        m.className = 'psp-pick-msg';
        m.setAttribute('role', 'status');
        group.appendChild(m);
      }
      m.textContent = 'Tap the size you wear to confirm it. Not sure? Open the size chart.';
    }, true);
  }

  // Gentle fade-up for homepage blocks as they scroll into view. Without JavaScript, nothing is hidden.
  function reveal() {
    var els = document.querySelectorAll('[data-psh-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    document.documentElement.classList.add('psh-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    [].forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  cleanGallery();

  function boot() {
    sizePopup();
    sizeGuard();
    reveal();
    var etas = document.querySelectorAll('[data-psp-eta]');
    [].forEach.call(etas, function (el) { renderEta(el); setInterval(function () { renderEta(el); }, 30000); });
    if (etas.length) {
      // Re-check after a size or color change: a sold-out choice hides the shipping estimate.
      var vs = document.querySelector('variant-selects');
      if (vs) vs.addEventListener('change', function () {
        setTimeout(function () { [].forEach.call(etas, renderEta); }, 350);
      });
      // The theme turns the add-to-cart button on or off when its stock check comes back,
      // which can take longer than the delay above on a slow connection.
      var pi = document.querySelector('product-info');
      if (pi && 'MutationObserver' in window) {
        new MutationObserver(function () { [].forEach.call(etas, renderEta); }).observe(pi, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
      }
    }
    [].forEach.call(document.querySelectorAll('[data-psp-clock]'), function (el) { renderClock(el); setInterval(function () { renderClock(el); }, 30000); });
    [].forEach.call(document.querySelectorAll('[data-psp-fitroot]'), finder);
    [].forEach.call(document.querySelectorAll('[data-psp-buy]'), function (a) { a.addEventListener('click', toBuy); });
    videos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
